module.exports = __webpack_public_path__ + "img/120d9d4.png";